import { render } from "./AddPracticeToDoctorForm.vue?vue&type=template&id=4a5b3930"
import script from "./AddPracticeToDoctorForm.vue?vue&type=script&lang=js"
export * from "./AddPracticeToDoctorForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__